import { createApi } from '@reduxjs/toolkit/query/react'
import getQuery from '../../helpers/api/get-query'
import ShiftType from '../../types/api/shift-type'
import Strapi, { EndpointQueryParameters } from '../../types/strapi/strapi'
import getCustomFetchBase from '../custom-fetch-base'

export const shiftTypesApi = createApi({
    reducerPath: 'shiftTypesApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['ShiftTypes'],
    endpoints: builder => ({
        getShiftTypes: builder.query<Strapi<ShiftType>, EndpointQueryParameters | void>({
            query: getQuery('/shift-types'),
            providesTags: ['ShiftTypes'],
        }),
    }),
})

export const { useGetShiftTypesQuery } = shiftTypesApi
